import { render, staticRenderFns } from "./GalleriesEdit.vue?vue&type=template&id=e0c43ca2&scoped=true&"
import script from "./GalleriesEdit.vue?vue&type=script&lang=js&"
export * from "./GalleriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c43ca2",
  null
  
)

export default component.exports